<template>
  <div id="healthcare" class="header-gap bo">
    <div class="sub-banner">
      <div class="container">
        <h1 v-html="$t('healthcare.banner-title')"></h1>
        <p v-html="$t('healthcare.banner-desc')"></p>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="column">
          <h2>{{$t("healthcare.doo-health")}}</h2>
          <p><i></i> {{$t("healthcare.doo-health-desc")}}</p>
          <a href="https://health.doo.com/" target="_blank" v-t="'business-overview.learn-more'"></a>
        </div>
        <div>
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/business_overview/healthCare_image1.png" />
        </div>
      </div>
    </div>
    <BOContactUs bocontent="healthcare"/>
  </div>
  <Modals />
</template>
  
<script setup>
  import "../less/style.css"
  import Modals from '@/components/Modals/ModalMain.vue'
  import BOContactUs from '@/components/BOContactUs.vue'

  import { useHead } from '@unhead/vue'
  import { useI18n } from 'vue-i18n'
  import { computed, onMounted } from 'vue'
  import { decodeHtml } from '@/utils'

  const { t } = useI18n()

  useHead({
    title: computed(() => decodeHtml(t('seo.healthcare.title'))),
    meta: [
      { name: 'description', content: computed(() => t('seo.healthcare.description')) },
      { name: 'keywords', content: computed(() => t('seo.healthcare.keywords')) },
    ],
  })

  onMounted(() => {
    if (typeof document !== 'undefined')
      document.dispatchEvent(new Event('prerender-ready'))
  })

</script>

<style lang="less">
  @import '../less/mediaQuery.less';

  #healthcare {
    .sub-banner {
      background:url('https://cdn.dootech.io/doo/business_overview/banner_healthCare.png') no-repeat 65% center / cover;
      @media @mobile-screen {
        background:url('https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/business_overview/banner_healthCare_mobile.png') no-repeat center top;
      }
      .container {
        @media only screen and (max-width:1500px) and (min-width:835px) {
          max-width: 40%;
          margin: 0;
        }
      }
    }
    @media only screen and (max-width:1400px) and (min-width:951px) {
      .container {
        padding:0 32px;
      }
    }
  }
</style>
